export default __webpack_public_path__ + "static/media/Ilustraciya_investor-exit-accelerator.a76be33c.svg";